<template>
    <div style="width: 100%; height: 56px">
        <div
            :class="`icons--wrapper-${steez} text-${
                page.series.length <= 2 ? 'center' : 'center'
            }`"
        >
            <span
                v-if="steez === 'stack' && page.series.length <= 2"
                class="hr-custom"
            >
            </span>
            <div
                v-for="icon in page.series"
                :key="icon._id"
                class="icon--series"
            >
                <EmbedSanityImage
                    v-if="icon.sanityThumbnail"
                    :selectedImage="
                        icon.sanityThumbnail &&
                        icon.sanityThumbnail.selectedImage
                    "
                    width="50"
                    height="40"
                    image-align="none"
                />
            </div>
            <span
                v-if="steez === 'stack' && page.series.length <= 2"
                class="hr-custom"
            >
            </span>
        </div>
    </div>
</template>
<script>
import EmbedCloudinary2 from '~/components/embeds/EmbedCloudinary2.vue'
import EmbedSanityImage from '~/components/embeds/EmbedSanityImage.vue'
export default {
    name: 'ProductIcons',
    components: {
        EmbedCloudinary2,
        EmbedSanityImage,
    },
    props: {
        page: {
            type: Object,
            default: null,
        },
        steez: {
            type: String,
            default: 'stack',
        },
    },
}
</script>
